import Monitoring from './MonitoringContainer';

export { Monitoring };



// WEBPACK FOOTER //
// ./src/modules/home/monitoring/index.js